export enum CollectiveAdStatus {
  OPEN = 'open',
  STARTED = 'started',
  COMPLETED = 'completed',
}
